module.exports = __webpack_public_path__ + "static/media/sweeney.0107f129.jpg";